import { TypeLatestArticlesBlockFields } from 'contentful-types'
import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import LatestArticlesBlock from './LatestArticlesBlock'

const ContentfulLatestArticlesBlock = withContentful<TypeLatestArticlesBlockFields>(LatestArticlesBlock, {
  blogCategory: (props) => props.fields.blogCategory,
  displayDate: (props) => props.fields.displayDate,
})

export default ContentfulLatestArticlesBlock
